import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=133eb05a&scoped=true"
import script from "./Connection.vue?vue&type=script&lang=js"
export * from "./Connection.vue?vue&type=script&lang=js"
import style0 from "./Connection.vue?vue&type=style&index=0&id=133eb05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133eb05a",
  null
  
)

export default component.exports